import React from 'react';
const facts = [{
  value: '129',
  label: 'Experiment Cards'
}, {
  value: '29',
  label: 'Printable worksheets'
}, {
  value: '6 + 5',
  label: 'Volumes & bonuses'
}, {
  value: '~300',
  label: 'Landscape pages'
}];

// Bandas de bloque, como en los tomos: A sage · B teal · C terracotta · D ochre
const accents = ['before:bg-sage', 'before:bg-teal', 'before:bg-terra', 'before:bg-ochre'];
export function SocialProofBar() {
  return <section className="w-full bg-sand" data-id="element-306" data-mp="32iblob6bodv2">
      <div className="mx-auto max-w-6xl px-5 py-10 sm:py-12" data-id="element-307" data-mp="2xk9uf2yqt88i">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-sand-dark bg-sand-dark sm:grid-cols-4" data-id="element-308" data-mp="2xhxdmt4q13x1">
          {facts.map((fact, i) => <div key={fact.label} className={`relative bg-cream px-4 py-5 text-center before:absolute before:inset-x-0 before:top-0 before:h-1 before:content-[''] ${accents[i]}`} data-id="element-309" data-mp="2oik1ttt4k395" data-mpi={i}>
              <div className="font-display text-3xl leading-none text-sage sm:text-4xl" data-id="element-310" data-mp="1d2vday082w68">
                {fact.value}
              </div>
              <div className="mt-1.5 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-311" data-mp="1dn5nbjb241le">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}